<script lang="ts">
  import { onMount } from 'svelte';
  import { writable } from 'svelte/store';

  export let end_date: Date | string;
  export let onFinished: () => void;

  const calculateTimeLeft = () => {
    const now = new Date();
    const distance = new Date(end_date).getTime() - now.getTime();

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const secs = Math.floor((distance % (1000 * 60)) / 1000);

    return [days, hours, mins, secs];
  };

  let time = writable(calculateTimeLeft());
  $: [days, hours, mins, secs] = $time;

  onMount(() => {
    let interval = setInterval(() => {
      $time = calculateTimeLeft();

      if ($time.filter((v) => v > 0).length == 0) {
        clearInterval(interval);
        onFinished();
      }
    }, 1000);

    return () => clearInterval(interval);
  });
</script>

{#if $time.filter((v) => v > 0).length > 0}
  <div class="text-sm text-gray-500 my-2">Tiempo restante:</div>
  <div class="grid grid-cols-8 gap-3">
    <span
      class="days border rounded-md py-3 px-3 flex flex-col items-center justify-center text-sm font-medium sm:flex-1 col-span-2"
    >
      <span> {days} </span>
      <span class="text-gray-500">{days == 1 ? 'día' : 'días'}</span>
    </span>
    <span
      class="hours border rounded-md py-3 px-3 flex flex-col items-center justify-center text-sm font-medium sm:flex-1 col-span-2"
    >
      <span> {hours} </span>
      <span class="text-gray-500">{hours == 1 ? 'hora' : 'horas'}</span>
    </span>
    <span
      class="mins border rounded-md py-3 px-3 flex flex-col items-center justify-center text-sm font-medium sm:flex-1 col-span-2"
    >
      <span> {mins} </span>
      <span class="text-gray-500">{mins == 1 ? 'min.' : 'mins.'}</span>
    </span>
    <span
      class="secs border rounded-md py-3 px-3 flex flex-col items-center justify-center text-sm font-medium sm:flex-1 col-span-2"
    >
      <span> {secs} </span>
      <span class="text-gray-500">{secs == 1 ? 'seg.' : 'segs.'}</span>
    </span>
  </div>
{/if}
